// src/Home.js
import React from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
} from "@mui/material";

// 11 adet tanıtım görseli
const demoData = [
  { id: 1, image: "https://korsananime.com/resimler/tanitim1.jpg" },
  { id: 2, image: "https://korsananime.com/resimler/tanitim2.jpg" },
  { id: 3, image: "https://korsananime.com/resimler/tanitim3.jpg" },
  { id: 4, image: "https://korsananime.com/resimler/tanitim4.jpg" },
  { id: 5, image: "https://korsananime.com/resimler/tanitim5.jpg" },
  { id: 6, image: "https://korsananime.com/resimler/tanitim6.jpg" },
  { id: 7, image: "https://korsananime.com/resimler/tanitim7.jpg" },
  { id: 8, image: "https://korsananime.com/resimler/tanitim8.jpg" },
  { id: 9, image: "https://korsananime.com/resimler/tanitim9.jpg" },
  { id: 10, image: "https://korsananime.com/resimler/tanitim10.jpg" },
  { id: 11, image: "https://korsananime.com/resimler/tanitim11.jpg" },
];

const Home = () => {
  return (
    <>
      {/* Üst Navigasyon */}
      <AppBar position="static" sx={{ backgroundColor: "#fff", color: "#000" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* Solda Logo */}
          <Box
            component="img"
            src="https://korsananime.com/resimler/animelogo.png"
            alt="KorsanAnime Logo"
            sx={{ height: 40 }}
          />

          {/* Sağ üstte Linkler */}
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              component={Link}
              to="/privacy-policy"
              variant="outlined"
              sx={{ textTransform: "none" }}
            >
              Gizlilik Politikası
            </Button>
            <Button
              component={Link}
              to="/terms-of-use"
              variant="outlined"
              sx={{ textTransform: "none" }}
            >
              Kullanım Şartları
            </Button>
            <Button
              component={Link}
              to="/about"
              variant="outlined"
              sx={{ textTransform: "none" }}
            >
              Hakkımızda
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Hero Bölümü */}
      <Container maxWidth="lg" sx={{ py: 10, textAlign: "center" }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: "bold", mb: 4 }}
        >
          Anime Tutkunlarının Yeni Adresi!
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: "text.secondary", maxWidth: 600, margin: "0 auto", mb: 4 }}
        >
          Anime tutkunları için özel olarak tasarlanan <strong>Toruko</strong>, reklamsız anime izleme ve birbirinden eğlenceli anime oyunlarıyla tam anlamıyla bir anime evreni sunuyor!
          <br />
          <br />
          <strong>Neler Sunuyoruz?</strong>
          <br />
          ✔ %100 Reklamsız Anime Deneyimi – Kesintisiz ve yüksek kaliteli anime izleme keyfi!
          <br />
          ✔ Zengin Anime Oyunları – Aksiyon, macera, RPG ve daha fazlasıyla anime dünyasını keşfedin!
          <br />
          ✔ Full HD Yayın Kalitesi – En sevdiğiniz animeleri en iyi görüntü kalitesinde izleyin!
          <br />
          ✔ Çevrimdışı İzleme & Oyun – Sevdiğiniz içerikleri indirip internet bağlantısı olmadan da keyfini çıkarın!
          <br />
          ✔ Google Play & App Store’da – Her an, her yerde anime dünyasına adım atın!
          <br />
          <br />
          Hemen <strong>Toruko</strong>’yi indir, reklamsız anime izlemenin ve anime oyunlarının keyfini doyasıya yaşa!
        </Typography>
      </Container>

      {/* Dikey telefon gibi görünecek resimler (Yatay kaydırmalı) */}
      <Container maxWidth="lg" sx={{ pb: 5 }}>
        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            gap: 3,
            px: 3,
          }}
        >
          {demoData.map((item) => (
            <Box
              key={item.id}
              sx={{
                flex: "0 0 auto",
                width: 200,
                height: 400,
                borderRadius: "24px",
                backgroundColor: "#000",
                overflow: "hidden",
                boxShadow: 3,
                position: "relative",
              }}
            >
              <Box
                component="img"
                src={item.image}
                alt={`Tanıtım Görseli ${item.id}`}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </>
  );
};

export default Home;
